import { InstantConfigGroup } from '../../models';
import { extractNegation, NegationObject } from './negation-extractor';

export class DeviceMatcher {
	constructor(private readonly currentDevice?: string) {}

	isValid(devices: InstantConfigGroup['devices'] = []): boolean {
		const deviceObjects = devices
			.map((browser) => browser.toLowerCase())
			.map((browser) => extractNegation(browser));

		if (deviceObjects.length === 0) {
			return true;
		}

		if (!this.currentDevice) {
			return true; // FIXME: na pewno? unit test
		}

		if (this.isCurrentNegated(this.currentDevice, deviceObjects)) {
			return false;
		}

		return deviceObjects.some((object) => (object.value === this.currentDevice) !== object.negated);
	}

	private isCurrentNegated(currentDevice: string, deviceObjects: NegationObject[]): boolean {
		return deviceObjects.some((object) => currentDevice.includes(object.value) && object.negated);
	}
}
